/**
 * OCT28 #6 (field test 2026-10-28) — the primary advisor's initials and a stable colour, for the cards.
 *
 * Presentation only: who the advisor IS comes from ticket_advisor_assignments (the persistent responsibility, never
 * custody). The colour is derived from the advisor's user id, so the same person keeps the same colour everywhere.
 */
const PALETTE = [
  'bg-sky-600 text-white', 'bg-emerald-600 text-white', 'bg-violet-600 text-white', 'bg-amber-500 text-black',
  'bg-rose-600 text-white', 'bg-teal-600 text-white', 'bg-indigo-600 text-white', 'bg-lime-500 text-black',
  'bg-fuchsia-600 text-white', 'bg-orange-500 text-black',
] as const;

/** "Fran Foh" → "FF"; "fran.i14e@t.test" → "FR"; single word → first two letters; nothing usable → "?". */
export function advisorInitials(name: string | null | undefined): string {
  const base = (name ?? '').trim().replace(/@.*$/, '');
  const words = base.split(/[\s._-]+/).filter((w) => /[A-Za-z0-9]/.test(w));
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

/** A stable palette class for one advisor (same user id → same colour). */
export function advisorColorClass(userId: string): string {
  let h = 0;
  for (let i = 0; i < userId.length; i++) h = (h * 31 + userId.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
